import { useAppStore } from '../../store/useAppStore.js';
import { GuidePendingView } from '../GuidePendingView.js';
import { VideoUploadScreen } from './VideoUploadScreen.js';
import { RipplingOnboardingScreen } from './RipplingOnboardingScreen.js';
import { ReviewWaitingScreen } from './ReviewWaitingScreen.js';

export function GuideStageRouter() {
  const role = useAppStore((s) => s.role);
  const stage = useAppStore((s) => s.applicationStage);

  // Pending non-guide (e.g. flagged learner) keeps the generic under-review screen.
  if (role !== 'guide' || !stage) return <GuidePendingView />;

  switch (stage) {
    case 'video_upload':        return <VideoUploadScreen />;
    case 'video_review':        return <ReviewWaitingScreen title="Your application is under review" body="Thanks for your submission! A reviewer is watching your intro video and reading your résumé. We'll email you within 1–5 business days." />;
    case 'rippling_onboarding': return <RipplingOnboardingScreen />;
    case 'financial_review':    return <ReviewWaitingScreen title="Your documents are under review" body="Rippling has everything. An ASL Go reviewer is giving your application a final look. We'll email you within 1–5 business days." />;
    default:                    return <GuidePendingView />;
  }
}
